"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_i18next_1 = require("react-i18next");
var core_1 = require("@material-ui/core");
// import statsBackground from '@assets/components/home/statistics-graphic/stats-background.svg'
var actions_1 = __importDefault(require("../actions"));
var format_1 = __importDefault(require("../../app/util/format"));
var SendIcon_1 = __importDefault(require("../../user/components/Drawer/ControlPanel/widgets/SendIcon"));
var constants_1 = require("../../../shared/constants");
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b, _c, _d, _e;
    return core_1.createStyles({
        grid: (_a = {
                marginTop: theme.spacing(6),
                marginBottom: theme.spacing(6),
                // backgroundImage: `url(${statsBackground})`,
                // backgroundColor: '#394B53',
                border: 'none'
            },
            _a[theme.breakpoints.up('md')] = {
                flexDirection: 'row',
            },
            _a[theme.breakpoints.down('sm')] = {
                flexDirection: 'column',
            },
            _a),
        card: (_b = {
                boxShadow: 'none',
                height: '100%',
                backgroundColor: 'transparent',
                alignItems: 'flex-start',
                paddingTop: theme.spacing(4),
                paddingBottom: theme.spacing(4)
            },
            _b[theme.breakpoints.up('md')] = {
                alignItems: 'flex-start',
                flexDirection: 'row',
            },
            _b[theme.breakpoints.up('lg')] = {
                alignItems: 'flex-start',
                flexDirection: 'row',
            },
            _b[theme.breakpoints.down('sm')] = {
                paddingTop: 0,
                paddingBottom: 0,
            },
            _b),
        cardContent: (_c = {
                paddingTop: theme.spacing(0),
                paddingLeft: theme.spacing(0),
                paddingRight: theme.spacing(2)
            },
            _c[theme.breakpoints.up('md')] = {
                paddingTop: theme.spacing(0),
            },
            _c.minWidth = '200px',
            _c),
        statsNumber: {
            fontFamily: "'Poppins', sans-serif",
            color: '#FFC700',
            fontSize: '38px',
            fontWeight: 800,
        },
        statsLabel: {
            marginTop: theme.spacing(0),
            color: theme.palette.primary.main,
            fontWeight: 700,
        },
        getStartedCard: (_d = {
                display: 'flex',
                marginTop: theme.spacing(4),
                boxShadow: 'none',
                width: '50%',
                height: '120px',
                backgroundColor: constants_1.THEME_COLOR.GET_STARTED_CARD,
                alignItems: 'center',
                justifyContent: 'space-around',
                flexDirection: 'row',
                border: "1px solid " + constants_1.THEME_COLOR.GET_STARTED_CARD,
                borderRadius: '10px',
                padding: theme.spacing(5),
                color: 'white'
            },
            _d[theme.breakpoints.down('sm')] = {
                flexDirection: 'column',
                height: 'auto',
                width: '80%',
                alignItems: 'center',
                justifyContent: 'center',
                padding: theme.spacing(3),
            },
            _d),
        getStartedButton: (_e = {
                paddingTop: theme.spacing(1),
                paddingBottom: theme.spacing(1),
                width: '100%',
                minWidth: '200px',
                borderRadius: '10px',
                backgroundColor: 'white',
                color: 'black',
                '&:hover': {
                    backgroundColor: 'white',
                }
            },
            _e[theme.breakpoints.up('sm')] = {
                width: '150px',
            },
            _e[theme.breakpoints.down('sm')] = {
                marginTop: theme.spacing(2),
                maxWidth: '200px',
            },
            _e),
        stats: {
            flexGrow: 0.8,
            width: '384px',
            maxWidth: '800px',
        },
    });
});
var StatisticsSliver = function () {
    var t = react_i18next_1.useTranslation().t;
    var classes = useStyles();
    var dispatch = react_redux_1.useDispatch();
    var loadStats = function () { return dispatch(actions_1.default.loadStats()); };
    var statistics = react_redux_1.useSelector(function (state) { return state.home.statistics; });
    // const theme = useTheme()
    // const isSmallWidth = useMediaQuery(theme.breakpoints.down('sm'))
    var userCount = statistics.userCount, linkCount = statistics.linkCount, clickCount = statistics.clickCount, fileCount = statistics.fileCount, agencyCount = statistics.agencyCount;
    // ensure number will never be null
    var statisticsToShow = [
        {
            label: t('general.officerOnBoard').toUpperCase(),
            number: userCount,
        },
        { label: t('general.shortLinkCreated'), number: linkCount },
        { label: t('general.click'), number: clickCount },
        { label: t('general.fileUploaded'), number: fileCount },
        { label: t('general.agencyOnBoard'), number: agencyCount },
    ];
    // Call once
    react_1.useEffect(function () {
        loadStats();
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Typography, { variant: "h3", color: "textPrimary", align: "center" }, t('general.linkAdmins')),
        react_1.default.createElement(core_1.Grid, { container: true, item: true, spacing: 2, wrap: "nowrap", className: classes.grid }, statisticsToShow.map(function (stat) { return (react_1.default.createElement(core_1.Grid, { item: true, xs: 12, md: 3, key: stat.label },
            react_1.default.createElement(core_1.Card, { className: classes.card },
                react_1.default.createElement(core_1.CardContent, { className: classes.cardContent },
                    react_1.default.createElement(core_1.Grid, { container: true, direction: "column", justifyContent: "center", alignItems: "center" },
                        react_1.default.createElement(core_1.Typography, { className: classes.statsNumber },
                            react_1.default.createElement("strong", null,
                                format_1.default.format(stat.number),
                                " +")),
                        react_1.default.createElement(core_1.Typography, { className: classes.statsLabel, variant: "body2" }, stat.label)))))); })),
        react_1.default.createElement(core_1.Grid, { container: true, spacing: 2, direction: "row", justifyContent: "center", alignItems: "center" },
            react_1.default.createElement(core_1.Card, { className: classes.getStartedCard },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(core_1.Typography, { variant: "h4" }, t('general.appCatchphrase.readyToGetStart'))),
                react_1.default.createElement(core_1.Button, { className: classes.getStartedButton, href: "/#/login", size: "medium", color: "primary", variant: "contained" },
                    react_1.default.createElement(core_1.Typography, { style: { marginRight: '10px' } }, t('button.getStarted')),
                    react_1.default.createElement(SendIcon_1.default, { color: "black" }))))));
};
exports.default = StatisticsSliver;
